import {
  currentBreakpoint as breakpoint,
  currentOrientation as orientation,
} from "@gr-exports/async/viewport";
import { isPreview } from "@gr-exports/async/misc";
import type { Breakpoint, BreakpointUnknown } from "../breakpoint/types.js";
import type { Orientation, OrientationUnknown } from "../orientation/types.js";

const { submitEvent } = otto.tracking;

let orientationCurrent: Orientation | OrientationUnknown;
let breakpointCurrent: Breakpoint | BreakpointUnknown;

/**
 *
 */
export const updtateTrackingViewportData = (): void => {
  [orientationCurrent, breakpointCurrent] = [orientation.get()!, breakpoint.get()!];
};

let breakpointTimer: number | undefined | NodeJS.Timeout;
let orientationTimer: number | undefined | NodeJS.Timeout;

/**
 *
 *
 *
 *
 *
 */
function sendTracking(orientationChanged: boolean, breakpointChanged: boolean): void {
  /*                                   */
  if (isPreview(window.location.href)) return;

  const sendData = {
    ot_BreakpointChange: [breakpointChanged.toString()],
    ot_OrientationChange: [orientationChanged.toString()],
  };

  submitEvent(sendData);
}

function handleOrientationChange(co: Orientation | OrientationUnknown = "unknown"): void {
  if (breakpointCurrent === breakpoint.get()) {
    sendTracking(true, false);
    orientationCurrent = co;
    return;
  }

  clearTimeout(breakpointTimer);
  sendTracking(true, true);
  updtateTrackingViewportData();
}

function handleBreakpointChange(bp: Breakpoint | BreakpointUnknown): void {
  if (orientationCurrent === orientation.get()) {
    /*                                          */
    sendTracking(false, true);
    breakpointCurrent = bp;
    return;
  }

  clearTimeout(orientationTimer);
  sendTracking(true, true);
  updtateTrackingViewportData();
}

export const orientationChangeListener = (
  co: Orientation | OrientationUnknown = "unknown",
): void => {
  /*                                                                                                                 */
  /*                                                                        */
  /*                                                               */

  /*                                                                                         */
  orientationTimer = setTimeout(() => handleOrientationChange(co), 500);
};

export const breakpointChangeListener = (bp: Breakpoint | BreakpointUnknown = "unknown"): void => {
  /*                                                                                         */
  breakpointTimer = setTimeout(() => handleBreakpointChange(bp), 500);
};
